const parseActiveVendorList = (vendorList: string): [] => {
  try {
    return JSON.parse(vendorList);
  } catch (error) {
    return [];
  }
};

export default parseActiveVendorList;
